(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shookpc-coverflow"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCoverflow(section) {
    const panels = Array.from(section.querySelectorAll('[data-cf-panel]'));
    const dots = Array.from(section.querySelectorAll('[data-cf-dot]'));
    const total = panels.length;
    if (total === 0) return;

    let current = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;

    function getState(panelIndex, activeIndex) {
      const diff = (panelIndex - activeIndex + total) % total;
      if (diff === 0) return 'active';
      if (diff === 1) return 'next';
      if (diff === total - 1) return 'prev';
      return 'hidden';
    }

    function render(activeIndex) {
      panels.forEach((panel, i) => {
        panel.setAttribute('data-cf-state', getState(i, activeIndex));
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('shookpc-cf__dot--active', i === activeIndex);
      });
    }

    function goTo(index) {
  current = (index + total) % total;
  render(current);
  panels.forEach((panel) => {
    const imgLink = panel.querySelector('.shookpc-cf__img-link');
    if (imgLink) {
      imgLink.style.pointerEvents = panel.getAttribute('data-cf-state') === 'active' ? 'auto' : 'none';
    }
  });
}

    panels.forEach((panel) => {
      panel.addEventListener('click', () => {
        const state = panel.getAttribute('data-cf-state');
        if (state === 'next') goTo(current + 1);
        if (state === 'prev') goTo(current - 1);
      });
    });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goTo(i));
    });

    section.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true });

    section.addEventListener('touchmove', (e) => {
      const diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
      const diffY = Math.abs(e.changedTouches[0].screenY - touchStartY);
      if (diffX > diffY && diffX > 10) {
        isSwiping = true;
        e.preventDefault();
      }
    }, { passive: false });

    section.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].screenX;
      if (isSwiping && Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });

    render(0);

    if (total > 1) {
      let introStep = 0;
      const introInterval = setInterval(() => {
        introStep++;
        if (introStep >= total) {
          clearInterval(introInterval);
          goTo(0);
          return;
        }
        goTo(introStep);
      }, 1800);
    }
  }

  document.querySelectorAll('[id^="ShookCF-"]').forEach(initCoverflow);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shookpc-series"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSeriesCarousel(carousel) {
    const slides = Array.from(carousel.querySelectorAll('[data-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-dot]'));
    const prevBtn = carousel.querySelector('[data-prev]');
    const nextBtn = carousel.querySelector('[data-next]');
    const speedSetting = carousel.dataset.autoplaySpeed;
    const speed = parseInt(speedSetting) * 1000 || 5000;
    let current = 0;
    let timer = null;
    let paused = false;

    function goTo(index, direction) {
  const next = (index + slides.length) % slides.length;
  if (next === current) return;

  const exitClass = direction === 'prev'
    ? 'shookpc-series__slide--exit-right'
    : 'shookpc-series__slide--exit';
  const enterFrom = direction === 'prev'
    ? 'shookpc-series__slide--enter-right'
    : 'shookpc-series__slide--enter-left';

  const outgoing = slides[current];
  const incoming = slides[next];
  const outgoingDot = dots[current];
  const incomingDot = dots[next];

  // Update current immediately
  current = next;

  // Lock all other slides
  slides.forEach((s) => {
  if (s !== outgoing && s !== incoming) {
    s.style.transition = 'none';
    s.style.opacity = '';
    s.style.transform = '';
    s.classList.remove('shookpc-series__slide--active');
  }
});

  // Exit outgoing
  outgoing.classList.remove('shookpc-series__slide--active');
  outgoing.classList.add(exitClass);
  if (outgoingDot) outgoingDot.classList.remove('shookpc-series__dot--active');

  // Stage incoming off-screen
  incoming.style.transition = 'none';
  incoming.classList.add(enterFrom);

  setTimeout(() => {
    incoming.style.transition = '';
    incoming.classList.remove(enterFrom);
    incoming.classList.add('shookpc-series__slide--active');
    if (incomingDot) incomingDot.classList.add('shookpc-series__dot--active');
  }, 20);

  // Cleanup outgoing after animation
 setTimeout(() => {
  outgoing.style.transition = 'none';
  outgoing.style.opacity = '';
  outgoing.style.transform = '';
  outgoing.classList.remove(
    'shookpc-series__slide--exit',
    'shookpc-series__slide--exit-right',
    'shookpc-series__slide--enter-left',
    'shookpc-series__slide--enter-right'
  );
  requestAnimationFrame(() => { outgoing.style.transition = ''; });
}, 700);
}

    function startTimer() {
      if (paused) return;
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1, 'next'), speed);
    }

    function stopTimer() {
      clearInterval(timer);
    }

    const pauseBtn = carousel.querySelector('[data-pause]');
    if (pauseBtn) {
      pauseBtn.addEventListener('click', () => {
        paused = !paused;
        pauseBtn.textContent = paused ? '▶' : 'II';
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        paused ? stopTimer() : startTimer();
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => { stopTimer(); goTo(current - 1, 'prev'); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { stopTimer(); goTo(current + 1, 'next'); startTimer(); });
    dots.forEach(dot => dot.addEventListener('click', () => { stopTimer(); goTo(parseInt(dot.dataset.dot), 'next'); startTimer(); }));

    carousel.addEventListener('mouseenter', stopTimer);
    carousel.addEventListener('mouseleave', startTimer);

    // Mobile swipe — prevents page scroll on horizontal swipe
    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;

    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      isSwiping = false;
    }, { passive: true });

    carousel.addEventListener('touchmove', (e) => {
      const diffX = Math.abs(e.changedTouches[0].screenX - touchStartX);
      const diffY = Math.abs(e.changedTouches[0].screenY - touchStartY);
      if (diffX > diffY && diffX > 10) {
        isSwiping = true;
        e.preventDefault();
      }
    }, { passive: false });

    carousel.addEventListener('touchend', (e) => {
      const touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (isSwiping && Math.abs(diff) > 50) {
        stopTimer();
        diff > 0 ? goTo(current + 1, 'next') : goTo(current - 1, 'prev');
        startTimer();
      }
    }, { passive: true });

    if (slides.length > 1) startTimer();
  }

  document.querySelectorAll('[data-series-carousel]').forEach(initSeriesCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
